<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { templateService } from "../../../../services/saleservice/template.service";
import { contracttypeService } from "../../../../services/settingservice/contracttype.service";
import List from "../../../../components/list";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Contract Templates List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      templatesList: {},
      contractTypesList: {},
      fetchingStats: false,
      title: "Contract Templates List",

    };
  },
  mounted() {
    
    this.loadingContractTypeData();
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      templateService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.templatesList = response;
        });
    },

    loadingContractTypeData: function() {
      contracttypeService.getList()
        .then(response => {
          this.contractTypesList = response;

        });
    },

    deleted: function(id) {
      templateService.remove(id)
        .then(response => {
        
          // this.customerData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-contract-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-contract-add'}" :title="$t('setting.configuration.contract-template.text')" />
    <List v-bind:dataList="templatesList" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[]"
          v-bind:fields="[ `contract_type: ${$t('setting.configuration.contract-template.type')}`,
            `name: ${$t('setting.configuration.contract-template.name')}`]" 
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'setting-contract-edit'}"
          v-bind:filter="{
            search: ['templates.name'],
            dropdown: [{
              title: 'setting.configuration.contract-template.type',
              field: 'templates.contract_type_id',
              data: this.contractTypesList.data,
            }],

          }"
          
    />      
  </Layout>
</template>